import React, { Component, Fragment } from 'react';
import './Ranking.css';

class RankingDetail extends Component {
  state = {
    index: this.props.index,
    info: this.props.info
  }

  render() {
    const { index } = this.state;
    const { name, like, url } = this.state.info;
    let newIndex = index;
    switch(index) {
      case 0:
        newIndex = '🥇';
        break;
      case 1:
        newIndex = '🥈';
        break;
      case 2:
        newIndex = '🥉';
      break;
      default:
        newIndex += 1
        
    }
    
    return(
      <Fragment>
        <th scope="row" className={'index index'+index}>{newIndex}</th>
        <td className="row-img"><img src={url} alt="uploaded" /></td>
        <td><div className="row-info">
          <div><b>{name}</b></div>
          <div>{like}</div>
        </div></td>
      </Fragment>
    );
  }
}
export default RankingDetail;